import React from "react";
import { useNavigate } from "react-router-dom";
import FormularioDistribuidor from "./FormularioDistribuidor";
import { cadastrarDistribuidor } from "../services/api";

const NovoDistribuidor = ({ token }) => {
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    await cadastrarDistribuidor(data, token);
    alert("Distribuidor cadastrado com sucesso!");
    navigate("/distribuidores");
  };

  return <FormularioDistribuidor token={token} onSubmit={handleSubmit} />;
};

export default NovoDistribuidor;
